import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo } from "react";
import ScrollTable from "../../../../Tables/ScrollTable/ScrollTable";
import { Icon } from "@mui/material";
import { IconButton } from "@material-ui/core";
import { show } from "redux-modal";
import { useDispatch } from "react-redux";
import { get, memoize } from "lodash";

const ServiceValuationFormStepOne = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { values, setSelectedServices, selectedServices } = props;
  const servicePrice = values?.device?.printerModel?.servicePrice || {};
  const valuationServices = values?.valuationServices || {};

  const showModal = (name, props) => {
    dispatch(show(name, props))
  }

  const dataRowsNames = ["repairPrice", "diagnosticsPrice","surveyPrice","installationPrice","itServicePrice"];
  useEffect(() => {

    const loaderSelectedServices = Object.keys(servicePrice).map((key) => {
      if(!dataRowsNames.includes(key)) return null;
      return {
        name: t(`global:servicevaluationtable.${key}`),
        laborHours: get(valuationServices, `${key}LaborHours`, 0),
        hourlyRate: get(valuationServices, `${key}HourlyRate`, get(servicePrice, `${key}`, 0)),
        key: key
      }
    }).filter((el) => Boolean(el));
    if(loaderSelectedServices.length<=0) return;
    setSelectedServices(loaderSelectedServices);
    // eslint-disable-next-line
  }, [servicePrice])

  const summaryTable = useMemo(() => selectedServices?.reduce((acc, el) => {
    return acc + (Number(el?.laborHours || 0) * Number(el?.hourlyRate || 0));
  }, 0), [selectedServices]);

  const summaryNetto = (el) => ((Number(el?.laborHours || 0) * Number(el?.hourlyRate || 0))?.toFixed(2));

  const memoizedSummaryNetto = memoize(summaryNetto);

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <Row>
        <Col style={{ marginTop: "4.5rem" }}>
          <ScrollTable height="25rem"
            headers={[
              { key: "name", name: t("global:servicevaluation.name"), width: "10em" },
              { key: "laborHours", name: t("global:servicevaluation.laborHours"), width: "5em" },
              { key: "hourlyRate", name: t("global:servicevaluation.hourlyRate"), width: "7em" },
              { key: "netto", name: t("global:servicevaluation.netto"), width: "7em" },
              { key: "button", width: "4em" }
            ]}
            data={selectedServices?.map((el, idx) => ({
              ...el,
              selected:!Boolean(el?.laborHours>0),
              laborHours: `${el?.laborHours} ${t(`global:servicePrice:${get(servicePrice,`${el?.key?.replace("Price","Value")}`)}`)}`,
              hourlyRate: `${Number(el?.hourlyRate).toFixed(2)} PLN`,
              netto: `${memoizedSummaryNetto(el)} PLN`,
              button: <>
                <IconButton
                  onClick={() => {
                    showModal("editServiceValuationServiceModal", {
                      initialValues: {
                        laborHours: Boolean(el?.laborHours) ? el?.laborHours : 1,
                        hourlyRate: Boolean(el?.hourlyRate) ? el?.hourlyRate : 0,
                      },
                      selectedElement: el,
                      setSelectedServices: setSelectedServices,
                      index: idx,
                    });
                  }}
                >
                  <Icon className="primary text" fontSize={"small"}>
                    edit
                  </Icon>
                </IconButton>
              </>
            }))} />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col className="d-flex justify-content-end me-5">
          <b>{t("global:servicevaluation.summary")}: <span className="ms-5">{summaryTable?.toFixed(2)} PLN + 23% VAT</span></b>
        </Col>
      </Row>
    </div >
  );
};

export default ServiceValuationFormStepOne;
